import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

export const fmt = (n) =>
  `${Number(n).toFixed(2).replace(".", ",")} €`;

export const WHATSAPP_URL =
  "https://wa.me/15148260610?text=" +
  encodeURIComponent("Salut S'NO ! J'ai une question.");

export const FREE_SHIPPING_THRESHOLD = 150;
